import { GridView, TableRows } from '@mui/icons-material'
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import {
  Button,
  ButtonGroup,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Typography,
} from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import { Fragment, useContext, useEffect, useState } from 'react'
import { puedeInsertar } from '../libs/PermisosHelper'
import { ExpedientesContext } from '../providers/ExpedientesProvider'
import ExpedienteCard from './ExpedienteCard'
import { ExpedientesTable } from './ExpedientesTable'
import ExpedienteView from './ExpedienteView' // <-- import the new view component

export default function ListaExpedientes() {
  const {
    active: { current },
    expedientes_usuario,
    regresar,
    setAltaExpediente,
    setOrigen,
    subirFichero,
    setExpedienteActual,
    mostrar,
    setMostrar,
  } = useContext(ExpedientesContext)

  const [viewType, setViewType] = useState('GRID')
  const [verExpediente, setVerExpediente] = useState(false)
  const [expedienteSeleccionado, setExpedienteSeleccionado] = useState(null)

  useEffect(() => {
    if (!expedientes_usuario?.loading) {
      expedientes_usuario.refetchExpedientes(mostrar)
    }
  }, [mostrar])

  function abrirExpediente(expediente) {
    setExpedienteSeleccionado(expediente)
    setExpedienteActual(expediente)
    setVerExpediente(true)
  }

  function cerrarExpediente() {
    setExpedienteSeleccionado(null)
    setExpedienteActual(null)
    setVerExpediente(false)
  }

  function subirArchivo(file) {
    if (!expedienteSeleccionado) return

    const tipo_documento = 'defaultTipoDoc' // replace as needed
    const tipo_expediente = expedienteSeleccionado.tipo_expediente || 'defaultTipoExp'

    subirFichero(file, tipo_documento, tipo_expediente)
  }

  const hasMore = () => {
    return expedientes_usuario?.response?.total_registros > mostrar
  }

  const handleMostrarMas = () => {
    setMostrar(mostrar + 12)
  }

  if (verExpediente && expedienteSeleccionado) {
    return (
      <ExpedienteView
        expediente={expedienteSeleccionado}
        onBack={cerrarExpediente}
        onUpload={subirArchivo}
      />
    )
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <ButtonGroup>
          <Button
            variant={viewType === 'TABLE' ? 'contained' : 'text'}
            color={'primary'}
            onClick={() => {
              setViewType('TABLE')
            }}
          >
            <TableRows />
          </Button>
          <Button
            variant={viewType === 'TABLE' ? 'text' : 'contained'}
            color={'primary'}
            onClick={() => {
              setViewType('GRID')
            }}
          >
            <GridView />
          </Button>
        </ButtonGroup>
      </Box>

      {viewType === 'GRID' ? (
        <Fragment>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              width: '100%',
              marginBottom: 2,
            }}
          >
            <Button
              sx={{
                margin: '5px',
                display: { xs: 'none', md: 'flex' },
              }}
              startIcon={<ArrowBackIcon />}
              variant="contained"
              color="primary"
              onClick={() => regresar()}
            >
              Volver
            </Button>
            {puedeInsertar(current) && (
              <Button
                sx={{
                  margin: '5px',
                  display: { xs: 'none', md: 'flex' },
                }}
                startIcon={<AddCircleRoundedIcon />}
                variant="contained"
                color="success"
                onClick={() => {
                  setOrigen('listadoExpedientes')
                  setAltaExpediente(true)
                  setExpedienteSeleccionado(null)
                  setVerExpediente(false)
                }}
              >
                Nuevo Expediente
              </Button>
            )}
          </Box>
          {expedientes_usuario?.loading ? (
            <Grid container spacing={2}>
              {[...Array(12).keys()].map((id, index) => {
                return (
                  <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
                    <Card key={id}>
                      <CardActionArea data-menu-item={id}>
                        <CardContent>
                          <Box>
                            <Skeleton
                              variant="rounded"
                              animation="wave"
                              height={24}
                              sx={{ width: '75%' }}
                            />
                          </Box>
                        </CardContent>
                      </CardActionArea>
                      <CardActions sx={{ justifyContent: 'flex-end' }}>
                        <Skeleton variant="circular" height={24} width={24} />
                      </CardActions>
                    </Card>
                  </Grid>
                )
              })}
            </Grid>
          ) : (
            <Grid container spacing={2}>
              {expedientes_usuario?.response?.expedientes?.length === 0 ? (
                <Box sx={{ width: '100%', textAlign: 'center', mt: 5 }}>
                  <Typography variant="h5">No se han encontrado resultados</Typography>
                </Box>
              ) : (
                expedientes_usuario?.response?.expedientes?.map((expediente, id) => (
                  <Grid key={id} item size={{ xs: 12, sm: 6, md: 3 }}>
                    <ExpedienteCard data={expediente} onClick={() => abrirExpediente(expediente)} />
                  </Grid>
                ))
              )}
            </Grid>
          )}
          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Button
              variant="text"
              size="large"
              onClick={handleMostrarMas}
              disabled={expedientes_usuario?.loading || !hasMore()}
            >
              {expedientes_usuario?.loading
                ? 'Cargando...'
                : hasMore()
                  ? 'Mostrar más'
                  : 'No hay más registros'}
            </Button>
          </Box>
        </Fragment>
      ) : expedientes_usuario?.response?.expedientes?.length === 0 ? (
        <Box sx={{ width: '100%', textAlign: 'center', mt: 5 }}>
          <Typography variant="h5">No se han encontrado resultados</Typography>
        </Box>
      ) : (
        <ExpedientesTable
          expedientes={expedientes_usuario?.response?.expedientes}
          abrirExpediente={abrirExpediente}
        />
      )}
    </Box>
  )
}
